import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";
import moment from 'moment'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import SettingsRounded from "@material-ui/icons/SettingsRounded"; 
import CancelIcon from "@material-ui/icons/Cancel";
import CheckIcon from "@material-ui/icons/CheckCircle";
import IconButton from '@material-ui/core/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";
import Datetime from "react-datetime";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import "assets/scss/custom/react-adjustments-table-inline-input.css";


// Actions
import {
  adjustmentFilter,
  adjustmentsFetch,
  adjustmentRemove,
  setAdjustmentViewFilter,
  approveAdjustment,
  declineAdjustment
} from 'actions/adjustments'

import {
  adjustmentsReasonsFetchAll
} from 'actions/adjustmentsReasons'

import {
  ibsFetchAll,
  ibFilter
} from 'actions/ibs'

import {
  userFetch
} from 'actions/users'

import {
  adjustmentStatus
} from 'enums'
//import Button from "components/CustomButtons/Button.jsx";


class List extends React.Component {
  selected=[]
  state = {
    ibList: [],
    selected: [],
    statusSelect: [{value:'APPROVED', name:'APPROVED'},{value:'REQUESTED_WITHDRAWAL', name:'REQUESTED APPROVAL'},{value:'DECLINED', name:'DECLINED'}],
    ibId: 0,
    status: '',
    from: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(8,'day').format(),
    to: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format(),
        
    
  }
  componentWillMount(){
    //this.approveAdjustment = this.approveAdjustment.bind(this)
    //this.declineAdjustment = this.declineAdjustment.bind(this)
  }
  componentDidMount(){
    //this.filter({sort:{adjustmentId: 'asc',status: 'asc',description: 'asc',time: 'asc'}, size:10, from:moment(new Date()).subtract(7,'day').startOf('day').format(), to:moment(new Date()).startOf('day').format()})
    
    //let fromFormat = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(8,'day').format();
    //let toFormat = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    let fromFormat = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(8,'day').format()
    let toFormat = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(0,'day').format()
      

    this.props.fetch(this.state.ibId,Date.parse(fromFormat),Date.parse(toFormat),this.state.status);
    this.props.adjustmentsReasonsFetchAll();
    this.props.userFetch();
    this.props.ibsFetchAll().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

    }); 
  }

  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch();
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Adjustments (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} adjustments \n( ${
          this.state.selected.map(id=>this.props.adjustments.list.find(e=>e.adjustmentId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.adjustments.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.adjustments.pageable.page
    })
    this.props.fetch()
  }
  approveAdjustment(id,comment) {
    
    let mycomment = ( ( this.state['commentText'+id] ) ? this.state['commentText'+id] : ( (comment !== undefined) && (comment !== null) ? comment : '' ) );
    this.props.approveAdjustment(id,mycomment);
    
    if ( this.state['commentText'+id] ) {
      delete this.state['commentText'+id];
      this.setState(this.state);
        
    }

    window.location.reload();
    
    
  }
  
  declineAdjustment(id,comment) {

    let mycomment = ( ( this.state['commentText'+id] ) ? this.state['commentText'+id] : ( (comment !== undefined) && (comment !== null) ? comment : '' ) );    
    this.props.declineAdjustment(id,mycomment);

    if ( this.state['commentText'+id] ) {
      delete this.state['commentText'+id];
      this.setState(this.state);
      
    }

    window.location.reload();
    
    
  }
 
getIbsName(ibId,ibs){

  let ibName = '';

  ibs.forEach(i => {
    if  (i.ibId===ibId) {
      ibName =  i.name+' '+i.lastName+' ('+i.ibId+')';
    }
  })

  return ibName;
   
}


getAdjustmentReasonName(reasonId,adjustmentReasons){

  let reasonName = '';

  adjustmentReasons.forEach(i => {
    if  (i.adjustmentReasonId===reasonId) {
      reasonName =  i.name;
    }
  })

  return reasonName;
   
}

getUserName(userId,users) {

  let userName = '';

  if (!this.props.users.isFetching) {
  
    Object.keys(users.list).forEach(key => {
  
      if (users.list[key].userId === userId) {
        userName = users.list[key].name+' ( '+users.list[key].userId+' )';
      }
  
    })
     
  }


  return userName;
   
}

handleChange(e, filter){
    let state = this.state
    let value = filter === 'from' || filter === 'to' ? e : e.target.value
    
    //this.setState({[filter]: value},() => this.fetchReport())

    state[filter] = value

    /*let propertyName = filter
    let data = {
      filterName: propertyName,
      value: e.target.value
    }

    this.props.setAdjustmentViewFilter(data)*/
    this.setState({...state},() => this.fetchReport())
    
  }
  fetchReport(){
    const{from, to, ibId,status} = this.state
    
    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();


    this.props.fetch(ibId,Date.parse(fromFormat),Date.parse(toFormat),status);
  }

onChange(e, filter){
    let state = this.state
    let value = e.target.value

    state[filter] = value
    this.setState({...state})
    
  }


renderFilters(){
    const {classes,ibs} = this.props
    const {ibId,status,statusSelect,ibList} = this.state
    
    const fromDate = this.state.from
      ? moment(this.state.from).startOf('day').format('YYYY-MM-DD')
      : ''

    const toDate = this.state.to
      ? moment(this.state.to).endOf('day').format('YYYY-MM-DD')
      : ''

    // const tomorrow = moment.utc(new Date()).add(1,'days').endOf('day')
    // const valid = (current) => {
    //   return current.isBefore(tomorrow)
    // }

    return (
      <GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="ibId" className={classes.selectLabel}>
              IB
            </InputLabel>
            <Select
              value={ibId}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "ibId"),
                id: "ibId",
                name: "ibId"
              }}>
              <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={0}>
              {'All'}
            </MenuItem>
              { ibList.length && 
                ibList.map((e) => (
                  <MenuItem
                    key={e.ibId}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.ibId}>
                    {e.firstName+' '+e.lastName+' ('+e.ibId+')'}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
          
        </GridItem>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="status" className={classes.selectLabel}>
              Status
            </InputLabel>
            <Select
              value={status}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "status"),
                id: "status",
                name: "status"
              }}>
              <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={null}>
              {'All'}
            </MenuItem>
              {statusSelect
                .map((e) => (
                  <MenuItem
                    key={e.value}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.value}>
                    {e.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
      
        <GridItem xs={3}>
            
            <FormControl className={classes.selectFormControl} style={{paddingTop: '13px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel} style={{marginTop: '-25px'}}>Date Created: <strong>From</strong></InputLabel>
            
              <Datetime
                id="from"
                name="from"
                props={{
                  name:"from"
                }}
                dateFormat={'YYYY-MM-DD'}
                timeFormat={false}
                inputProps={{
                  id:"from",
                  name:"from",
                  readOnly:true,
                  placeholder: 'yyyy/mm/dd'
                }}
                onChange={(event) => this.handleChange(event, "from")}
                utc={true}
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                value={fromDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
            </FormControl>
        </GridItem>

        <GridItem xs={3}>
          <FormControl className={classes.selectFormControl} style={{paddingTop: '13px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel} style={{marginTop: '-25px'}}>Date Created: <strong>To</strong></InputLabel>
              <Datetime
                id="from"
                name="to"
                props={{
                  name:"to"
                }}
                dateFormat={'YYYY-MM-DD'}
                timeFormat={false}
                inputProps={{
                  id:"to",
                  name:"to",
                  readOnly:true,
                  placeholder: 'yyyy/mm/dd'
                }}
                onChange={(event) => this.handleChange(event, "to")}
                utc={true}
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                value={toDate}
                className={classes.select + ' ' + classes.datepickerText}
              />

          </FormControl>
        </GridItem>
        
        
        
      </GridContainer>
    )
  }


  render() {
    const {adjustments, match, adjustmentReasons, ibs, users} = this.props;
    const { ibList } = this.state;
    
    const selected = this.state.selected

    return (
      <GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={12}>
      <Card>
        {this.state.alert}
        {
        ((!adjustments.isFetching) && (!users.isFetching))?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={adjustments.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={adjustments.pageable.totalPages>1?{
            pages:adjustments.pageable.totalPages,
            current:adjustments.pageable.page+1,
          }:false}
          // title={this.getTableTitle()}
          dark={selected.length>0}
          icon={<SettingsRounded/>}
          actions={{
            add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('ADJUSTMENTS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? ''
              // <Link to={`${match.path}/${this.state.selected[0]}`}>
              //     <IconButton>
              //         <EditIcon/>
              //     </IconButton>
              //   </Link>
              : ''
        }}/>:''}

        <CardBody>
        {this.renderFilters()}
          {/* If is fetching not display table*/}
          {(adjustments.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <div style={{border:'1px solid #FFFFFF', marginTop: '20px'}}>
              <Table style={{ width: '1200px !important' }}
                striped
                firstChildFullWidth
                hover
                tableHeaderColor="primary"
                sort={adjustments.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:adjustments.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                tableHead={{ 
                    checkbox:{name: <Checkbox props = {{ 
                      onClick:()=>this.select(adjustments.list.map(e=>e.adjustmentId)),
                      checked:this.state.selected.length===adjustments.list.length
                    }}/>,width: '30px'},
                    adjustmentId:"#", 
                    ibId: "IB Name", 
                    reasonId: "Reason of Adjustment",  
                    usdAmount: "Amount USD", 
                    description: "Period of Adjustment",
                    approvingUserId:"Approving Operator",
                    changeStatusTime: "Status Time",
                    status: "Status",
                    creatingUserId: "Created By",
                    creationTime: "Date Created",
                    commentText: "Text/Comment",
                    actions: {name:'',width: '100px'}
                  }}
                tableData={adjustments.list.map((e,i) => [ 
                    ((e.status!=='APPROVED')?<Checkbox props = {{ onClick:()=>this.select(e.adjustmentId), checked:this.state.selected.indexOf(e.adjustmentId)>-1 }}/>:''), 
                    e.adjustmentId, 
                    this.getIbsName(e.ibId,ibList), 
                    this.getAdjustmentReasonName(e.reasonId,adjustmentReasons), 
                    e.usdAmount, 
                    e.description, 
                    this.getUserName(e.approvingUserId,users),
                    moment(e.changeStatusTime).format('YYYY-MM-DD HH:mm:ss'),
                    ((e.status==='APPROVED' || e.status==='DECLINED' || e.status==='REQUESTED_WITHDRAWAL')?adjustmentStatus[e.status].label.replace("_", " "):'REQUESTED APPROVAL'),
                    this.getUserName(e.creatingUserId,users),
                    moment(e.creationTime).format('YYYY-MM-DD HH:mm:ss'),
                    ((e.status==='REQUESTED_WITHDRAWAL')?
                    <div className="adjustment-inline-div adjustment-inline-div-underline adjustment-inline-div-underline-custom"><input type="text" className="adjustment-inline-input-text adjustment-inline-custom-input-text" id={`commentText${e.adjustmentId}`} name={`commentText${e.adjustmentId}`} onChange={event => this.onChange(event,'commentText'+e.adjustmentId)} placeholder={( (e.comment !== undefined) && (e.comment !== null) ? e.comment : 'Add Text' )} /></div>
                    :e.comment),
                    ((e.status==='REQUESTED_WITHDRAWAL')?
                    <div>
                      <IconButton onClick={ev => this.approveAdjustment(e.adjustmentId,e.comment)} style={{color: '#4caf50'}}>
                        <CheckIcon/>
                      </IconButton>
                      <IconButton onClick={ev => this.declineAdjustment(e.adjustmentId,e.comment)} style={{color: '#f44336'}}>
                        <CancelIcon/>
                      </IconButton>
                    </div>:'')
                  ] )}/>
                </div>
            )}
        </CardBody>
       { 
         adjustments.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={adjustments.pageable.totalPages>1?{
              pages:adjustments.pageable.totalPages,
              current:adjustments.pageable.page+1,
            }:false}
        />:''}
      </Card>
      </GridItem>
      </GridContainer>
    );
  }
}
const mapStateToProps = (state) => ({
  auth:state.auth,
  adjustments: state.adjustments,
  adjustmentReasons: state.adjustmentsReasons.listAll,
  ibs: state.ibs,
  users: state.users,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(adjustmentFilter(filter)),
  fetch: (ibId,from,to,status,loading) => dispatch(adjustmentsFetch(ibId,from,to,status,loading)),
  fetchReasons: () => dispatch(adjustmentsReasonsFetchAll()),
  remove: (id) => dispatch(adjustmentRemove(id)),
  setAdjustmentViewFilter: (data) => dispatch(setAdjustmentViewFilter(data)),
  approveAdjustment: (id,comment) => dispatch(approveAdjustment(id,comment)),
  declineAdjustment: (id,comment) => dispatch(declineAdjustment(id,comment)),
  adjustmentsReasonsFetchAll: () => dispatch(adjustmentsReasonsFetchAll()),
  ibsFetchAll: () => dispatch(ibsFetchAll()),
  ibFilter: (filter) => dispatch(ibFilter(filter)),
  userFetch: (filter) => dispatch(userFetch(filter)),
})
export default withStyles(buttonsStyle)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Adjustments/List.jsx